import { useContext } from 'react'
import { AppContext } from '@state/context'
import useSWR from 'swr'
import { Single_Student } from '@graphql/queries'

const useStudent = () => {
  const [state] = useContext(AppContext)
  const {
    app: { userId },
  } = state

  const { data, error, mutate, isValidating } = useSWR([Single_Student, userId])

  const student = data?.customer ? data?.customer : null

  return {
    student,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useStudent }
